var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7513 1.83335L8.2513 1.83335C3.66797 1.83335 1.83464 3.66669 1.83464 8.25002L1.83464 13.75C1.83464 18.3334 3.66797 20.1667 8.2513 20.1667L13.7513 20.1667C18.3346 20.1667 20.168 18.3334 20.168 13.75L20.168 8.25002C20.168 3.66669 18.3346 1.83335 13.7513 1.83335Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84365 7.76417L13.0703 11L9.84365 14.2358",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackCart);
export default __webpack_public_path__ + "static/media/back-cart.f3e95dcf0b16d0937c7c8199bc54aabc.svg";
export { ForwardRef as ReactComponent };